<template>
  <div>
    <aside class="sidebar">
      <button id="global-search" class="search" :class="{ 'has-banner': hasBanner }" @click="openSearch()">
        <!-- <img src="/images/svgs/search-white.svg" alt="Boffa Miskell Search"> -->
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>ico/search</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="home-1" transform="translate(-18.000000, -760.000000)" fill="currentColor">
              <g id="ico/search" transform="translate(18.000000, 760.000000)">
                <g id="Fill-1">
                  <path
                    d="M13.9306413,17.7948384 C9.47429298,17.7948384 5.84926478,14.2404067 5.84926478,9.8719203 C5.84926478,5.50295137 9.47429298,1.94900216 13.9306413,1.94900216 C18.3869896,1.94900216 22.0120178,5.50295137 22.0120178,9.8719203 C22.0120178,14.2404067 18.3869896,17.7948384 13.9306413,17.7948384 M3.86128258,9.8719203 C3.86128258,12.3425544 4.79842497,14.5989382 6.33457066,16.3322424 L0,22.5421232 C1.46526938,23.9786618 0,22.5421232 1.46526938,23.9786618 L7.82494206,17.7436886 C7.83281721,17.7359679 7.83773918,17.7267995 7.84561432,17.7185962 C9.53827854,18.9833486 11.6429113,19.7438406 13.9306413,19.7438406 C19.4826193,19.7438406 24,15.315036 24,9.8719203 C24,4.42832206 19.4826193,0 13.9306413,0 C8.37817108,0 3.86128258,4.42832206 3.86128258,9.8719203 Z"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>

      <a v-if="!hideContact" href="/contact" class="contact">Contact</a>

      <a :href="data.linkedin" target="_blank" class="linkedin">
        <svg
          width="24px"
          height="23px"
          viewBox="0 0 24 23"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch -->
          <title>linkedin-logo</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="home-1" transform="translate(-18.000000, -672.000000)" fill="currentColor">
              <path
                d="M42,686.100667 L42,695 L36.8553333,695 L36.8553333,686.697388 C36.8553333,684.612041 36.112,683.188602 34.25,683.188602 C32.828,683.188602 31.983,684.147033 31.6106667,685.075377 C31.4753333,685.407 31.44,685.867996 31.44,686.333004 L31.44,695 L26.2943333,695 C26.2943333,695 26.3633333,680.937108 26.2943333,679.481243 L31.44,679.481243 L31.44,681.680252 C31.4296667,681.697301 31.4153333,681.71435 31.4063333,681.731065 L31.44,681.731065 L31.44,681.680252 C32.1236667,680.625209 33.3436667,679.116859 36.0766667,679.116859 C39.4623333,679.116859 42,681.334254 42,686.100667 Z M20.9113333,672 C19.151,672 18,673.158341 18,674.681066 C18,676.171029 19.1183333,677.363134 20.8436667,677.363134 L20.8776667,677.363134 C22.672,677.363134 23.7876667,676.171029 23.7876667,674.681066 C23.754,673.158341 22.672,672 20.9113333,672 Z M18.306,695 L23.4493333,695 L23.4493333,679.481243 L18.306,679.481243 L18.306,695 Z"
                id="linkedin-logo"
              ></path>
            </g>
          </g>
        </svg>
      </a>
    </aside>

    <div :class="{ open: isOpen }" class="search-popup">
      <a href="/" class="logo">
        <img src="/images/svgs/logo.svg" alt="Boffa Miskell" />
      </a>
      <img src="/images/svgs/close-menu.svg" alt="Close" class="close" @click="searchClose()" />
      <div class="search">
        <input ref="searchbar" type="text" placeholder="Search..." v-model="keyword" v-on:keyup.enter="onSearch" />
        <img class="searh-btn" src="/images/search-large.svg" alt="Search" @click="onSearch" />
      </div>
      <div class="popular-searches" v-if="popular.length != 0">
        <h6>POPULAR SEARCHES</h6>
        <div class="flex flex-wrap searches">
          <a :href="i.search_link ?? ''" v-for="(i,k) in popular" :key="k">{{i.search_name}}</a>
          <!-- <a href="#">Filium morte multavit</a>
          <a href="#">At periculum adiit</a>
          <a href="#">Repudiandae sint</a>
          <a href="#">Sunt autem vel</a>
          <a href="#">Conclusionemque rationis</a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: [Array,Object],
    searchOpen: Boolean,
    popular: [Array,Object],
    hasBanner: Boolean,
  },
  data() {
    return {
      keyword : '',
      isOpen: false,
      hideContact: false,
    }
  },
  watch: {
    searchOpen(newOpen, oldOpen) {
     this.isOpen = newOpen
   }
 },
  mounted() {
    this.isOpen = this.searchOpen
    // console.log(this.data)
    if(window.location.href.indexOf('/what-we-do/') != -1) {
      this.hideContact = true
    }

  },
  methods: {
    openSearch() {
      this.isOpen = true
      this.$refs.searchbar.focus()
    },
    onSearch() {
      window.location.href = "/search?keyword="+this.keyword;
    },
    searchClose() {
      this.isOpen = false
      this.$emit('searchClose')
    }
  }
}
</script>
